<mat-card class="mb-3">
    <mat-card-header>
        <mat-card-title>Sincronización SAP</mat-card-title>
        <mat-card-subtitle>Sincronice los datos de vendedores y comisionamiento desde SAP</mat-card-subtitle>
    </mat-card-header>
</mat-card>

<div class="row g-3">
    <div class="col-12 col-md-3">
        <mat-card>
            <mat-card-header>
                <mat-card-title>Configuración</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <form [formGroup]="form" class="d-flex flex-column gap-3">
                    <mat-form-field appearance="outline">
                        <mat-label>Periodo</mat-label>
                        <mat-select formControlName="periodo">
                            <mat-option *ngFor="let periodo of periodosAbiertos" [value]="periodo.periodo">
                                {{periodo.periodo}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('periodo')?.hasError('required')">
                            El periodo es requerido
                        </mat-error>
                    </mat-form-field>

                    <button mat-flat-button color="primary" 
                            [disabled]="isLoading || form.invalid"
                            (click)="sincronizar()">
                        <mat-icon class="me-2">sync</mat-icon>
                        Iniciar Sincronización
                    </button>
                </form>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="col-12 col-md-9 mt-3">
        <div class="row mb-4">
            <div class="col-md-6">
                <mat-card>
                    <mat-card-content>
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-muted">Vendedores y administradores</div>
                                <div class="h2 mb-0" *ngIf="!loadingStates.vendedores">{{stats.totalVendedores}}</div>
                                <mat-spinner *ngIf="loadingStates.vendedores" [diameter]="30"></mat-spinner>
                            </div>
                            <mat-icon class="text-primary fs-1">people</mat-icon>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="col-md-6">
                <mat-card>
                    <mat-card-content>
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-muted">Factor de comisiones de vendedores</div>
                                <div class="h2 mb-0" *ngIf="!loadingStates.comisiones">{{stats.totalComisiones}}</div>
                                <mat-spinner *ngIf="loadingStates.comisiones" [diameter]="30"></mat-spinner>
                            </div>
                            <mat-icon class="text-primary fs-1">paid</mat-icon>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>

            
        </div>

        <div class="row g-3 mt-3">
            <div class="col-md-6">
                <mat-card>
                    <mat-card-content>
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-muted">Factor de comisiones de administradores</div>
                                <div class="h2 mb-0" *ngIf="!loadingStates.comisionesJefes">{{stats.totalComisionesJefes}}</div>
                                <mat-spinner *ngIf="loadingStates.comisionesJefes" [diameter]="30"></mat-spinner>
                            </div>
                            <mat-icon class="text-primary fs-1">supervisor_account</mat-icon>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="col-md-3">
                <mat-card>
                    <mat-card-content>
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-muted">Ausentismos</div>
                                <div class="h2 mb-0" *ngIf="!loadingStates.ausentismos">{{stats.totalAusentismos}}</div>
                                <mat-spinner *ngIf="loadingStates.ausentismos" [diameter]="30"></mat-spinner>
                            </div>
                            <mat-icon class="text-primary fs-1">event_busy</mat-icon>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>

            <div class="col-md-3">
                <mat-card>
                    <mat-card-content>
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <div class="text-muted">ETL</div>
                                <div class="status-badge"
                                     [class.status-processed]="etlStatus.status === 'processed'"
                                     [class.status-error]="etlStatus.status === 'error'"
                                     [class.status-processing]="etlStatus.status === 'processing'"
                                     [class.status-not-processed]="etlStatus.status === 'not_processed'">{{ etlStatus.message }}</div>
                            </div>
                            <mat-icon class="text-primary fs-1">transform</mat-icon>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</div>

<mat-card class="mt-3">
    <mat-card-header>
        <mat-card-title>Progreso de Sincronización</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <mat-horizontal-stepper [linear]="true" [selectedIndex]="currentStep" class="custom-stepper">
            <mat-step *ngFor="let step of steps; let i = index" [completed]="step.status === 'completed'">
                <ng-template matStepLabel>
                    <div class="d-flex align-items-center gap-2 step-label">
                        <div class="step-title">{{step.title}}</div>
                        <mat-icon *ngIf="step.status === 'completed'" class="text-success step-icon">check_circle</mat-icon>
                        <mat-icon *ngIf="step.status === 'error'" class="text-danger step-icon">error</mat-icon>
                    </div>
                </ng-template>
                
                <div class="py-3">
                    <mat-progress-bar 
                        *ngIf="step.status === 'in-progress'"
                        mode="indeterminate"
                        color="primary"
                        class="step-progress">
                    </mat-progress-bar>
                    <mat-progress-bar 
                        *ngIf="step.status === 'completed'"
                        mode="determinate"
                        [value]="100"
                        color="primary"
                        class="step-progress">
                    </mat-progress-bar>
                    <div *ngIf="step.status === 'error'" class="text-danger mt-2 step-error">
                        <mat-icon class="align-middle me-1">warning</mat-icon>
                        Ha ocurrido un error en este paso
                    </div>
                </div>
            </mat-step>
        </mat-horizontal-stepper>
    </mat-card-content>

    <style>
        /* Estilos para el stepper */
        .custom-stepper {
            padding: 1rem;
        }
        
        /* Hacer los pasos más anchos */
        ::ng-deep .mat-horizontal-stepper-header {
            padding: 0 1  !important;
            height: auto !important;
            min-height: 72px !important;
        }

        /* Mejorar la legibilidad del texto */
        .step-label {
            white-space: normal !important;
            text-align: center;
            min-height: 48px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .step-title {
            font-size: 0.9rem;
            line-height: 1.2;
            margin-bottom: 0.25rem;
        }

        /* Iconos más visibles */
        .step-icon {
            font-size: 1.25rem;
            height: 1rem;
            width: 1rem;
        }

        /* Barra de progreso más visible */
        .step-progress {
            height: 6px;
            border-radius: 3px;
        }

        /* Mensaje de error más visible */
        .step-error {
            font-size: 0.9rem;
            padding: 0.5rem;
            border-radius: 4px;
            background-color: rgba(244, 67, 54, 0.1);
        }

        /* Mejorar la visibilidad de los conectores entre pasos */
        ::ng-deep .mat-stepper-horizontal-line {
            min-width: 15px !important;
            border-top-width: 2px !important;
        }

        /* Responsive: en móviles hacer el stepper vertical */
        @media (max-width: 768px) {
            ::ng-deep .mat-horizontal-stepper-header-container {
                flex-direction: column !important;
            }

            ::ng-deep .mat-horizontal-stepper-header {
                padding-bottom: 1rem !important;
                width: 100% !important;
            }

            ::ng-deep .mat-stepper-horizontal-line {
                border-left-width: 2px !important;
                min-height: 24px !important;
                margin: 0 !important;
            }
        }
    </style>
</mat-card>
